function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect } from "react";
import { Form, Input, Button, Descriptions, Divider, Alert, Radio, Tag, Upload } from 'antd';
import Common from "../includes/Common";
import { Upload as UploadIcon } from 'react-bootstrap-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var SaveDrugData = function SaveDrugData(_ref) {
  var candidat = _ref.candidat,
      handler = _ref.handler,
      _ref$update = _ref.update,
      update = _ref$update === void 0 ? false : _ref$update;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isFormProcessing = _useState2[0],
      setIsFormProcessing = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      errorMessage = _useState4[0],
      setErrorMessage = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      file = _useState6[0],
      setFile = _useState6[1];

  var _Form$useForm = Form.useForm(),
      _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
      form = _Form$useForm2[0];

  var onFinish = function onFinish(values) {
    setErrorMessage('');
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    formData.append("attached_file", file);
    formData.append("alcool", values.alcool);
    formData.append("amphetamine", values.amphetamine);
    formData.append("benzodiazepine", values.benzodiazepine);
    formData.append("cannabinoide", values.cannabinoide);
    formData.append("opiace", values.opiace);
    formData.append("c", values.cocaine);
    axios.post(Common.baseApiUrl + "setdrugdata", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      setErrorMessage("Une erreur est survenue");
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };

  useEffect(function () {
    if (update == true) {
      form.setFieldsValue(_defineProperty({
        alcool: candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.alcool : "",
        amphetamine: candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.amphetamine : "",
        benzodiazepine: candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.benzodiazepine : "",
        cannabinoide: candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.cannabinoide : "",
        opiace: candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.opiace : ""
      }, "opiace", candidat.laboratory_result.drug_test != null ? candidat.laboratory_result.drug_test.opiace : ""));
    }

    form.setFieldsValue({
      comment: ""
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      form: form,
      layout: "horizontal",
      onFinish: onFinish,
      children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          type: "error",
          message: errorMessage,
          banner: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Alcool",
        name: "alcool",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Amphetamines",
        name: "amphetamine",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Benzodiazepines",
        name: "benzodiazepine",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Cannabinoides",
        name: "cannabinoide",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Opiaces",
        name: "opiace",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Cocaine",
        name: "cocaine",
        children: /*#__PURE__*/_jsxs(Radio.Group, {
          buttonStyle: "solid",
          children: [/*#__PURE__*/_jsx(Radio.Button, {
            value: 0,
            children: "N\xE9gatif"
          }), /*#__PURE__*/_jsx(Radio.Button, {
            value: 1,
            children: "Positif"
          })]
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          loading: isFormProcessing,
          htmlType: "submit",
          type: "primary",
          children: /*#__PURE__*/_jsx("b", {
            children: "VALIDER"
          })
        })
      })]
    })
  });
};

export default SaveDrugData;